module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="apexchat_scripts_multiple_choice_main_div_' +
((__t = (id)) == null ? '' : __t) +
'"\r\n    class="apexchat_message livechat_message_wrapper apexchat_question_type_custom_style_div ';
 if(userId == -1){ ;
__p += ' apexchat_system';
};

 if(userId == 0){ ;
__p += ' apexchat_visitor';
};

 if(userId > 0 || userId == -3){ ;
__p += ' apexchat_agent';
};
__p += ' apexchat_script_message_' +
((__t = (id)) == null ? '' : __t) +
'">\r\n    <div class="apexchat_question_type_single_col radio">\r\n        <div class="livechat_message_bubble_wrapper">\r\n            ';
 if (userId !==0 && handlerImageUrl) { ;
__p += '\r\n                <div class="apexchat_message_avatar_wrapper">\r\n                    <img src="' +
((__t = (handlerImageUrl)) == null ? '' : __t) +
'" class="apexchat_ada_compliance" tabindex="0" alt="Live Agent"\r\n                        title="Live Agent" role="img" name="image" />\r\n                </div>\r\n                ';
 } ;
__p += '\r\n                    <div class="apexchat_speaker">\r\n                        <div class="livechat_message_bubble">\r\n                            <div id="apexchat_question_type_div_close_button_' +
((__t = (id)) == null ? '' : __t) +
'">\r\n                                <!--<div title="Close" id="apexchat-btn-skip-' +
((__t = (id)) == null ? '' : __t) +
'" class="apexchat_question_type_close_button"></div>-->\r\n                            </div>\r\n                            <!-- <div class="apexchat_text apexchat_speaker apexchat_participant_display_text"\r\n                                id="apexchat_participant_display_name">\r\n                                ' +
((__t = (participantDisplayName )) == null ? '' : __t) +
':&nbsp;\r\n                            </div>-->\r\n                            <div class="apexchat_speaker apexchat_participant_display_text"\r\n                                id="apexchat_participant_display_col">\r\n                            </div>\r\n                            <div class="apexchat_text apexchat_participant_display_text livechat_rd_fade_in_bottom"\r\n                                tabindex="0" id="apexchat_participant_display_text">\r\n                                <span>\r\n                                    ' +
((__t = (text )) == null ? '' : __t) +
'\r\n                                </span>\r\n                                <div id="apexchat_question_type_multiple_choice_file_div_' +
((__t = (id)) == null ? '' : __t) +
'"\r\n                                    class="livechat_files_container"></div>\r\n                            </div>\r\n                        </div>\r\n                        <!-- ' +
((__t = (participantDisplayName )) == null ? '' : __t) +
': ' +
((__t = (text )) == null ? '' : __t) +
' -->\r\n                        <span aria-hidden="true"\r\n                            class="apexchat_rd_timer_span livechat_rd_fade_in_bottom apexchat_rd_question_type_timer">\r\n                            <!--For Visitor-->\r\n                            ' +
((__t = (ApexChat.getCurrentFormatedDateTime(createdOn, 'hh:mmtt' ) )) == null ? '' : __t) +
'\r\n                        </span>\r\n                    </div>\r\n        </div>\r\n        <div id="apexchat_question_type_multiple_choice_options_div_' +
((__t = (id)) == null ? '' : __t) +
'"\r\n            class="apexchat_question_type_styled_input_container livechat_qt_options_inline">\r\n            apexchat_options_div\r\n        </div>\r\n        <div class="apexchat_skipMc livechat_skip" id="apexchat_skip_question_' +
((__t = (id)) == null ? '' : __t) +
'" style="display:none;"\r\n            tabindex="0" title="Skip this question" role="button">Skip this question</div>\r\n        <div id="apexchat-btn-update-' +
((__t = (id)) == null ? '' : __t) +
'" class="apexchat_question_type_update_container"><span\r\n                class="apexchat_question_type_update_button apexchat_element_on_focus" tabindex="0">Update</span></div>\r\n        <!--<div class="apexchat_question_confirm_or_skip_padding" id="apexchat_question_type_div_confirm_button_' +
((__t = (id)) == null ? '' : __t) +
'">            \r\n            <br/><br /><br /><i>(Click okay to send your selection(s) or x if you do not want to answer.)</i>\r\n        </div>-->\r\n    </div>\r\n</div>';

}
return __p
}